module.exports = __webpack_public_path__ + "img/Zhomebie05.ec5091b8.png";